import { render, staticRenderFns } from "./BookReports.vue?vue&type=template&id=71aa4be8&scoped=true&"
import script from "./BookReports.vue?vue&type=script&lang=js&"
export * from "./BookReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aa4be8",
  null
  
)

export default component.exports